import { paths } from '@luxuryescapes/contract-business'
import requestUtils, { authOptions } from 'api/requestUtils'

type EmployeeCreditCustomerIdUpdateServerResponse = paths['/api/business-traveller/businesses/{businessId}/employees/{employeeId}/credit-customer-id']['patch']['responses'][200]['content']['application/json']
type EmployeeCreditCustomerIdUpdateServerRequestPayload = paths['/api/business-traveller/businesses/{businessId}/employees/{employeeId}/credit-customer-id']['patch']['requestBody']['content']['application/json']

export enum EMPLOYEE_CREDIT_CUSTOMER_UPDATE_ERRORS {
  NOT_FOUND = 'Employee not found in the business!',
  ALREADY_SET = 'Credit recipient account has already been set!',
  OTHER = 'Something went wrong!',
}

async function requestPatchEmployeeCreditCustomerId(
  params: {
    businessId: string,
    employeeId: string,
  },
  payload: EmployeeCreditCustomerIdUpdateServerRequestPayload,
  accessToken: string,
) {
  const { businessId, employeeId } = params

  try {
    await requestUtils.patch<EmployeeCreditCustomerIdUpdateServerResponse, EmployeeCreditCustomerIdUpdateServerRequestPayload>(
      `/api/business-traveller/businesses/${businessId}/employees/${employeeId}/credit-customer-id?without_brand=1`,
      payload,
      authOptions(accessToken),
    )

    return true
  } catch(error: any) {
    switch (error?.message) {
      case 'Employee not found in the business':
        return Promise.reject(EMPLOYEE_CREDIT_CUSTOMER_UPDATE_ERRORS.NOT_FOUND)
      case 'Credit customer ID already set':
        return Promise.reject(EMPLOYEE_CREDIT_CUSTOMER_UPDATE_ERRORS.ALREADY_SET)
      default:
        return Promise.reject(EMPLOYEE_CREDIT_CUSTOMER_UPDATE_ERRORS.OTHER)
    }
  }
}

export default requestPatchEmployeeCreditCustomerId
